module.exports = __webpack_public_path__ + "img/experiences.5b65c398.svg";